import { BaseDropdown } from './component/BaseDropdown';
import { useDropdownOptions } from '../../hooks/useDropdownOptions';
import { BusinessDropdownProps } from './component/type';

const COLUMN_NAMES: string[] = ['Currency', 'Description'];

export const PurchaseCurrencyDropdown = (props: BusinessDropdownProps) => {
  const shouldPreventApiCall = props.disabled || props.readOnly;

  const { options: currencyOptions, loading } = useDropdownOptions({
    apiId: 'internal.v1.base-tables',
    operationId: 'GET /currencies',
    labelAttribute: 'description',
    valueAttribute: 'currency',
    shouldPreventApiCall,
  });

  return <BaseDropdown {...props} loading={loading} options={currencyOptions} columnNames={COLUMN_NAMES} />;
};
